import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { searchActions } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from '../relations/relationLink';
import RelationSection from '../relations/relationSection';

class ReliabilityTableSection extends React.Component {
    state = {
        expandMap: {},
        shouldExpandMap: {}
    };
    dataRefMap = {};

    render() {
        const data = this.props.data;
        const sectionType = this.props.sectionType;
        const sectionName = this.props.sectionName;

        return (
            <OldStyleSection name={this.props.translate(sectionName)} hasData={data && data.length > 0} isBold isReliability>
                <div>
                    {sectionType == 'relations' &&
                        <RelationSection data={{ relations: data }} pageSize={20} isReliability={true} isLimited={false} />
                    }
                    {sectionType == 'liquidity' && <>
                        <OldStyleTableWithHistory stripped classNames='table-report-section table-stretched'
                            head={() => {
                                return (
                                    <thead className='reliability-header'>
                                        {this.renderHeader(sectionType)}
                                    </thead>
                                );
                            }}
                            tableColumns={this.getTableColumnsCount(sectionType)}
                            actualData={data} actualRow={(d) => this.renderRow(d, data.length - 1, data, sectionType)}
                            isLimited={false} pageSize={20}
                        />
                        {this.renderFooter(sectionType)}
                    </>
                    }
                    {sectionType != 'relations' && sectionType !== 'liquidity' && <>
                        <table className="table old-style-table-report fixed table-report-section table-stretched">
                            <thead className='reliability-header'>
                                {this.renderHeader(sectionType)}
                            </thead>
                            <tbody>
                                {this.renderContent(data, sectionType)}
                            </tbody>
                        </table>
                        {this.renderFooter(sectionType)}
                    </>
                    }
                </div>
            </OldStyleSection>
        );
    }

    renderHeader(type) {
        switch (type) {
            case "liquidity":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold" style={{ width: '20%' }}><Translate id="Reliability.Table.Name" /></th>
                        <th className="bold" style={{ width: '15%' }}><Translate id="Reliability.Table.CompanyId" /></th>
                        <th className="bold" style={{ width: '20%' }}><Translate id="Reliability.Table.Warnings" /></th>
                        <th className="bold" style={{ width: '20%' }}><Translate id="Reliability.Table.Position" /></th>
                        <th className="bold" style={{ width: '10%' }}><Translate id="Reliability.Table.Share" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.ValidFrom" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.ValidTo" /></th>
                    </tr>
                );
            case "warnings":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold"><Translate id="Reliability.Table.Name" /></th>
                        <th className="bold col-company-id"><Translate id="Reliability.Table.CompanyId" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.Date" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.EndDate" /></th>
                        <th className="bold" style={{ width: '25%' }}><Translate id="Reliability.Table.Note" /></th>
                    </tr>
                );
            case "cnb":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold"><Translate id="Reliability.Table.Name" /></th>
                        <th className="bold col-company-id"><Translate id="Reliability.Table.CompanyId" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.Date" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.EndDate" /></th>
                        <th className="bold" style={{ width: '15%', textAlign: 'right' }}><Translate id="Report.Common.Value" /></th>
                        <th className="bold" style={{ width: '35%' }}><Translate id="Reliability.Table.Note" /></th>
                    </tr>
                );
            case "interuptionBusiness":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold col-date"><Translate id="Reliability.Table.Date" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.EndDate" /></th>
                        <th className="bold"><Translate id="Reliability.Table.Note" /></th>
                    </tr>
                );
            case "insolvency":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold col-date"><Translate id="Reliability.Table.StartDateOfProceedings" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.StateDate" /></th>
                        <th className="bold"><Translate id="Reliability.Table.State" /></th>
                        <th className="bold" style={{ width: '24%' }}><Translate id="Reliability.Table.Note" /></th>
                    </tr>
                );
            case "trades":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateFrom" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateTo" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.BrakeFrom" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.BrakeTo" /></th>
                        <th className="bold"><Translate id="Reliability.Table.BusinessScope" /></th>
                    </tr>
                );
            case "regisReg":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateFrom" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateTo" /></th>
                        <th className="bold"><Translate id="Reliability.Table.Description" /></th>
                        <th className="bold"><Translate id="Reliability.Table.SuperiorSubject" /></th>
                    </tr>
                );
            case "regisComp":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateFrom" /></th>
                        <th className="bold col-date"><Translate id="Reliability.Table.DateTo" /></th>
                        <th className="bold"><Translate id="Reliability.Table.Description" /></th>
                    </tr>
                );
            case "owner":
                return (
                    <tr style={{ borderTopWidth: 0 }}>
                        <th className="bold"><Translate id="Reliability.Table.Title" /></th>
                        <th className="bold"><Translate id="Reliability.Table.CompanyId" /></th>
                        <th className="bold"><Translate id="Reliability.Table.Type" /></th>
                        <th className="bold"><Translate id="Reliability.Table.Ratio" /></th>
                    </tr>
                );
            default:
                break;
        }
    }

    getTableColumnsCount(type) {
        switch (type) {
            case "liquidity": return 7;
            case "warnings": return 5;
            case "cnb": return 6;
            case "interuptionBusiness": return 3;
            case "insolvency": return 4;
            case "trades": return 5;
            case "regisReg": return 4;
            case "regisComp": return 3;
            case "owner": return 4;
            default: return 0;
        }
    }

    renderContent = (data, type) => {
        if (isNullOrUndefined(data))
            return null;

        return (
            <>
                {data.map((d, index) => this.renderRow(d, index, data, type))}
            </>
        )
    }

    renderRow = (d, index, data, type) => {
        switch (type) {
            case "liquidity":
                return (
                    <>
                        <tr key={d.id} className="colorize" style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td><RelationLink wrap entityName={d.name} entityId={d.entityId} reports={d.reports} customPrefix={<></>} showOnMobile={true} /></td>
                            <td>{d.companyId}</td>
                            <td>{this.renderWarnings(d.warnings, false)}</td>
                            <td>{d.position}</td>
                            <td>{d.share}</td>
                            <td>{d.validFromFormated}</td>
                            <td>{d.validToFormated}</td>
                        </tr>
                    </>
                );
            case "warnings":
                return (
                    <>
                        <tr key={d.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td><RelationLink wrap entityName={d.name} entityId={d.entityId} reports={d.reports} customPrefix={<></>} showOnMobile={true} /></td>
                            <td>{d.companyId}</td>
                            <td>{d.startDateFormated}</td>
                            <td>{d.endDateFormated}</td>
                            {this.renderWarningNote(d, true)}
                        </tr>
                    </>
                );
            case "cnb":
                return (
                    <>
                        <tr key={d.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td><RelationLink wrap entityName={d.name} entityId={d.entityId} reports={d.reports} customPrefix={<></>} showOnMobile={true} /></td>
                            <td>{d.companyId}</td>
                            <td>{d.startDateFormated}</td>
                            <td>{d.endDateFormated}</td>
                            <td style={{ textAlign: 'right' }}>{d.value}</td>
                            {this.renderWarningNote(d, true)}
                        </tr>
                    </>
                );
            case "interuptionBusiness":
                return (
                    <>
                        <tr key={d.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td>{d.startDateFormated}</td>
                            <td>{d.endDateFormated}</td>
                            <td>{d.description}</td>
                        </tr>
                    </>
                );
            case "insolvency":
                return (
                    <>
                        {
                            d.currentProceeding && <tr key={d.currentProceeding.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                                <td>{d.startOfProceedingsDateFormated}</td>
                                <td>{d.currentProceeding.startDateFormated}</td>
                                <td>{d.currentProceeding.description}</td>
                                {this.renderWarningNote(d.currentProceeding, false)}
                            </tr>}
                    </>
                );
            case "trades":
                return (
                    <>
                        <tr key={d.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td>{d.fromFormated}</td>
                            <td>{d.toFormated}</td>
                            <td>{d.breakStartFormated}</td>
                            <td>{d.breakEndFormated}</td>
                            <td>{d.activity}</td>
                        </tr>
                    </>
                );
            case "regisReg":
                return (
                    <>
                        <tr key={d.information.id} className="bold" style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td>{d.information.startDateFormated}</td>
                            <td>{d.information.endDateFormated}</td>
                            <td colSpan={2}>{d.information.description}</td>
                        </tr>
                        {d.jerrsRelations && d.jerrsRelations.map(x =>
                            <tr key={x.relationJerrsTypeCode}>
                                <td>{x.startDateFormated}</td>
                                <td>{x.endDateFormated}</td>
                                <td>{x.description}</td>
                                <td>{x.parentFullName}</td>
                            </tr>
                        )}
                    </>
                );
            case "regisComp":
                return (
                    <>
                        <tr key={d.id} className={classnames({ 'bold': d.isRoot })} style={d.isHistorical ? { fontStyle: 'italic', color: '#949494', borderBottomWidth: index === data.length - 1 ? 0 : "1px" } : { borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td>{d.startDateFormated}</td>
                            <td>{d.endDateFormated}</td>
                            <td>{d.description}</td>
                        </tr>
                    </>
                );
            case "owner":
                return (
                    <>
                        <tr key={d.id} style={{ borderBottomWidth: index === data.length - 1 ? 0 : "1px" }}>
                            <td><RelationLink wrap entityName={d.name} entityId={d.entityId} reports={d.reports} customPrefix={<></>} showOnMobile={true} /></td>
                            <td>{d.companyId}</td>
                            <td>{d.description}</td>
                            <td><span style={{ whiteSpace: "nowrap" }}>{d.shareFormated}<span className="l-padded r-padded">/</span></span></td>
                        </tr>
                    </>
                );
            default:
                break;
        }
    }

    renderFooter = (type) => {
        switch (type) {
            case "liquidity":
            case "warnings":
            case "cnb":
            case "interuptionBusiness":
                break;
            case "insolvency":
                return (
                    <div style={{ fontSize: "0.875em" }}>
                        <Translate id="Reliability.Insolvency.ClosedProceedings" />
                    </div>
                );
            case "trades":
            case "regisReg":
            case "regisComp":
            case "owner":
            default:
                break;
        }
    }

    renderWarningNote = (d, showLess) => {
        return (
            <td className='warning-note'>
                <span className={classnames({ 'text-shorten': !this.state.expandMap[d.id] })}>
                    <p ref={el => this.dataRefMap[d.id] = this.dataRefMap[d.id] || el}>{this.renderInsolvencyLink(d.note)}</p>
                    {showLess && !this.state.expandMap[d.id] && <span className="link-functional" onClick={() => this.showLess(d.id)}><Translate id="Report.Common.More" /></span>}
                    {showLess && this.state.expandMap[d.id] && <span className="link-functional" style={{ float: 'right' }} onClick={() => this.showLess(d.id)}><Translate id="Report.Common.Less" /></span>}
                </span>
            </td>
        )
    }

    showLess = (id) => {
        let expandMap = { ...this.state.expandMap };
        expandMap[id] = !expandMap[id];
        this.setState({ expandMap });
    }

    renderInsolvencyLink = (note) => {
        const validationRegex = /^INS \d+\/\d{4}$/;
        if (validationRegex.test(note).valueOf()) {
            const params = note.replace('INS ', '').split('/');
            let href = `https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?nazev_osoby=&vyhledat_pouze_podle_zacatku=on&podpora_vyhledat_pouze_podle_zacatku=true&jmeno_osoby=&ic=&datum_narozeni=&rc=&mesto=&cislo_senatu=&bc_vec=${params[0]}&rocnik=${params[1]}&id_osoby_puvodce=&druh_stav_konkursu=&datum_stav_od=&datum_stav_do=&aktualnost=AKTUALNI_I_UKONCENA&druh_kod_udalost=&datum_akce_od=&datum_akce_do=&nazev_osoby_f=&rowsAtOnce=50&spis_znacky_datum=&spis_znacky_obdobi=14DNI`;
            return <a href={href} className={classnames('link-external', { 'is-normal': localStorage.locales_url_format === 'normal' })} target="_blank">{note}</a>
        }
        return note;
    }

    renderWarnings = (warnings, historical = false) => {
        if (warnings === undefined || warnings === null || warnings.length === 0)
            return null;

        return (
            <React.Fragment>
                <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: 'wrap' }}>
                    {warnings.map((w, i) =>
                        <div key={`${i}_${w.code}`} className={`r-padded rel-warn rel-warn-status-${w.severity}${(historical ? " rel-warn-historical" : "")}`}
                            title={w.description}
                        >{w.code}
                        </div>)}
                </div>
            </React.Fragment>
        );
    }

    expandClicked = () => {
        this.setState({ expanded: !this.state.expanded })
    }
}

export default withRouter(withLocalize(connect(
    state => ({ layout: state.layout }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(ReliabilityTableSection)));